/**
 * Resolve /uploads/... paths for dev (CRA proxies /api only; uploads live on backend :8002).
 */
export function resolveMediaUrl(path) {
  if (!path) return '';
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  const base =
    typeof window !== 'undefined' && window.location.hostname === 'localhost'
      ? 'http://localhost:8002'
      : '';
  return `${base}${path.startsWith('/') ? path : `/${path}`}`;
}
